module.exports = {"apiKey":"AIzaSyD-QAthMw1u2jnHKOSHxNis6TZypOV2lmQ","authDomain":"advanced-sportclub-slate-dev.firebaseapp.com","databaseURL":"https://advanced-sportclub-slate-dev.firebaseio.com","projectId":"advanced-sportclub-slate-dev","storageBucket":"advanced-sportclub-slate-dev.appspot.com","messagingSenderId":"634335831593"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase.config.json
// module id = 443
// module chunks = 0